var Screens = {

    helpPanelShown: false,
    selectedCharacter: 0,
    selectedDifficulty: 0,
    heightChallengeKey: "height",
    defeatedChallengeKey: "defeated",
    collectiblesChallengeKey: "collectibles",
    challengeKeys: [
        "height",
        "defeated",
        "collectibles"
    ],
    challengeTypes: {
        "height": "record",
        "defeated": "cumulative",
        "collectibles": "cumulative"
    },
    json: {},
    upsideDown: false,


    /*
     LOADING SCREEN
     */
    loadingScreen: function () {
        var screenJson = Screens.json.screens.loadingScreen;

        var container = new PIXI.Container();
        var bg = Widgets.createBackgroundAsset(screenJson.bg);
        var barBack = Widgets.createAsset(screenJson.bar_back);
        var bar = Widgets.createAsset(screenJson.bar_fill);
        var barTop = Widgets.createAsset(screenJson.bar_top);
        // bar.texture.
        container.addChild(bg);
        container.addChild(barBack);
        container.addChild(bar);
        container.addChild(barTop);
        var mask = new PIXI.Graphics();
        mask.beginFill(0);
        mask.drawRect(0, -568, bar.width, 1136);
        mask.endFill();
        mask.x = -bar.width / 2;
        mask.x += bar.x;
        mask.y += bar.y;
        container.addChild(mask);
        bar.mask = mask;
        mask.scale.x = 0;

        var updateFunc = function () {
            mask.scale.x = ccLoader.progress / 100 || 0;
        };

        return {
            construct: container,
            color: screenJson.screenColour,
            update: updateFunc
        };
    },


    /*
     START SCREEN
     */
    startScreen: function () {


        if (window.top.orientation === 180) {
            this.upsideDown = true;
        }
        else {
            this.upsideDown = false;
        }

        var screenJson = Screens.json.screens.startScreen;
        if(Screens.json.audio.music.startScreen){
            sound.playMusic(Screens.json.audio.music.startScreen, 1);
        }

        var animTimer = 0;

        var container = new PIXI.Container();

        var bg = Widgets.createBackgroundAsset(screenJson.bg);

        var title = Widgets.createAsset(screenJson.title);

        var buttonStart = Widgets.createButtonAsset(
            screenJson.start_btn,
            function () {
                CC.WebApp.current.swapScreen(Screens.characterScreen());
            },
            undefined);

        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var settings_panel = Widgets.createSettingsMenu(Screens.json.ui.panel_settings, help_panel);
        var button_settings = Widgets.createButtonAsset(
            Screens.json.ui.button_settings,
            function () {
                settings_panel.show();
            },
            undefined);
        var screenItems = [bg, title, buttonStart, button_settings, settings_panel, help_panel];
        container.addChild(bg, title, buttonStart, button_settings, settings_panel, help_panel);

        var resizeFunc = function (w, h) {
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if (item.resize) {
                    item.resize(w, h);
                }
            }
        };

        var updateFunc = function (delta) {

            animTimer += delta;
            var modifier = Math.pow(Math.sin(animTimer * Math.PI), 12);
            buttonStart.scale.x = 1 + modifier * 0.1;
            buttonStart.scale.y = buttonStart.scale.x;

        };

        return {
            construct: container,
            color: screenJson.screenColour,
            update: updateFunc,
            resize: resizeFunc
        };
    },


    /*
     CHARACTER SCREEN
     */
    characterScreen: function () {

        var screenJson = Screens.json.screens.characterScreen;
        var record = localStorage.getItem(Screens.json.localStorageName);

        var animTimer = 0;

        var container = new PIXI.Container();
        var bg = Widgets.createBackgroundAsset(screenJson.bg);

        var buttonTick = Widgets.createButtonAsset(screenJson.tick_btn, function () {
            Screens.selectedCharacter = carousel.currentPos;
            showDifficulty();
        });
        var buttonPadlock = Widgets.createAsset(screenJson.padlock_btn);
        buttonPadlock.interactive = true;
        buttonPadlock.tweening = false;
        buttonPadlock.mousedown = function () {
            if (!this.tweening) {
                this.tweening = true;
                this.position.x += 40;
                TweenLite.to(this.position, 0.5, {
                    x: 0,
                    ease: Elastic.easeOut.config(1, 0.1),
                    onComplete: function () {
                        this.tweening = false;
                    }.bind(this)
                });
            }

        }.bind(buttonPadlock);
        buttonPadlock.touchstart = function () {
            this.position.x += 50;
            TweenLite.to(this.position, 0.5, {
                x: 0,
                ease: Elastic.easeOut.config(1, 0.1)
            });
        }.bind(buttonPadlock);
        var padlockText = new PIXI.extras.BitmapText("Reach " + 0 + " to unlock.", {
            font: "40px Futura",
            tint: screenJson.padlock_text.tint
        });
        Widgets.setAssetParams(padlockText, screenJson.padlock_text);

        var updateButtonLockStatus = function (locked, score) {
            buttonTick.visible = !locked;
            buttonPadlock.visible = locked;
            padlockText.visible = locked;
            if (locked) {
                padlockText.text = "Reach " + score + " to unlock.";
                padlockText.x = -padlockText.width / 2
            }
        }.bind(this);

        var items = [];
        var screenItems = [];
        var item, title, lockedTitle, i, character, itemJson;
        for (i = 0; i < screenJson.characters.length; ++i) {
            itemJson = screenJson.characters[i];
            item = new PIXI.Container();
            character = Widgets.createAsset(itemJson.image);
            character.scale.set(0);
            title = Widgets.createAsset(itemJson.title);
            lockedTitle = Widgets.createAsset(screenJson.locked_title);
            item.addChild(character);
            item.addChild(title);
            item.addChild(lockedTitle);
            if (itemJson.unlockScore && itemJson.unlockScore > record) {
                item.locked = true;
                item.unlockScore = itemJson.unlockScore;
                var tintGraphic = new PIXI.Graphics();
                tintGraphic.beginFill(0, 0.3);
                tintGraphic.drawRect(-320, -568, 640, 1136);
                tintGraphic.endFill();
                item.addChild(tintGraphic);
            } else {
                item.locked = false;
            }
            item.character = character;
            item.title = title;
            item.lockedTitle = lockedTitle;
            screenItems.push(title);
            item.hide = function () {
                TweenLite.killTweensOf(this);
                TweenLite.to(this.character, 0.2, {alpha: 0});
                TweenLite.to(this.character.scale, 0.3, {x: 0, y: 0});
                this.title.alpha = 0;
                this.lockedTitle.alpha = 0;
            }.bind(item);
            item.show = function () {
                TweenLite.killTweensOf(this);
                TweenLite.to(this.character, 0.2, {alpha: 1});
                TweenLite.to(this.character.scale, 0.3, {x: 1, y: 1, ease: Back.easeOut});
                if (!this.locked) {
                    this.lockedTitle.alpha = 0;
                    this.title.alpha = 0;
                    this.title.scale.set(0.8);
                    TweenLite.to(this.title, 0.2, {alpha: 1});
                    TweenLite.to(this.title.scale, 0.3, {x: 1, y: 1, ease: Back.easeOut});
                }
                else {
                    this.title.alpha = 0;
                    this.lockedTitle.alpha = 0;
                    this.lockedTitle.scale.set(0.8);
                    TweenLite.to(this.lockedTitle, 0.2, {alpha: 1});
                    TweenLite.to(this.lockedTitle.scale, 0.3, {x: 1, y: 1, ease: Back.easeOut});
                }
                updateButtonLockStatus(this.locked, this.unlockScore);
            }.bind(item);
            if (i === 0) {
                item.show();
            } else {
                item.hide();
            }
            items.push(item);
        }

        var carousel = Widgets.createSelectionCarousel(items, screenJson, 0);
        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var settings_panel = Widgets.createSettingsMenu(Screens.json.ui.panel_settings, help_panel);

        var button_home = Widgets.createButtonAsset(Screens.json.ui.button_home, function () {
            CC.WebApp.current.swapScreen(Screens.startScreen())
        });

        var button_settings = Widgets.createButtonAsset(Screens.json.ui.button_settings, function () {
            settings_panel.show();
        });

        var clickBlocker = Widgets.createClickBlocker();

        var overlay_difficulty;
        if (screenJson.overlay_difficulty) {
            overlay_difficulty = Widgets.createAsset(screenJson.overlay_difficulty);
        } else {
            overlay_difficulty = new PIXI.Container();
        }
        var easy_btn = Widgets.createButtonAsset(screenJson.easy_btn, function () {
            Screens.selectedDifficulty = 0;
            CC.WebApp.current.swapScreen(Screens.challengeDisplayScreen());
        });
        overlay_difficulty.addChild(easy_btn);
        var hard_btn = Widgets.createButtonAsset(screenJson.hard_btn, function () {
            Screens.selectedDifficulty = 1;
            CC.WebApp.current.swapScreen(Screens.challengeDisplayScreen());
        });
        overlay_difficulty.addChild(hard_btn);
        var showDifficulty = function () {
            container.addChild(clickBlocker);
            container.addChild(overlay_difficulty);
        };

        container.addChild(bg, carousel, buttonTick, buttonPadlock, padlockText, button_home, button_settings, settings_panel, help_panel);

        screenItems.push(bg, carousel, buttonTick, buttonPadlock, padlockText, button_home, button_settings, settings_panel, help_panel);

        var resizeFunc = function (w, h) {
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if (item && item.resize) {
                    item.resize(w, h);
                }
            }
        };

        var updateFunc = function (delta) {

            animTimer += delta;
            var modifier = Math.pow(Math.sin(animTimer * Math.PI), 12);
            buttonTick.scale.x = 1 + modifier * 0.1;
            buttonTick.scale.y = buttonTick.scale.x;

        };

        return {
            construct: container,
            color: 0xEEEEEE,
            update: updateFunc,
            resize: resizeFunc
        };
    },


    /*
     GAME SCREEN
     */
    gameScreen: function () {

        var screenJson = Screens.json.screens.gameScreen;

        if(Screens.json.audio.music.gameScreen) {
            sound.playMusic(Screens.json.audio.music.gameScreen);
        }

        var container = new PIXI.Container();
        var gameEndFunc = function (heightScore) {
            sound.stopAll();
            CC.WebApp.current.swapScreen(Screens.resultsScreen(heightScore));
        };
        var jumpGame = new JumpGame(gameEndFunc, Screens.selectedCharacter, Screens.selectedDifficulty, screenJson, Screens.json.audio);
        jumpGame.start();
        container.addChild(jumpGame);


        //UI
        var lastEnemyIndex = -1;
        var paused = false;
        var confirm_panel = Widgets.createConfirmationDialog(Screens.json.ui.panel_are_you_sure);
        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var closeFunction = function () {
            paused = false;
        }.bind(this);
        var pause_panel = Widgets.createPauseMenu(Screens.json.ui.panel_paused, help_panel, confirm_panel, closeFunction);
        var button_pause = Widgets.createButtonAsset(
            Screens.json.ui.button_pause,
            function () {
                pause_panel.show();
                paused = true
            },
            true);

        var jump_button = Widgets.createButtonAsset(
            Screens.json.screens.gameScreen.jump_button,
            jumpGame.jumpPressed.bind(jumpGame),
            true
        );

        var setJumpButtonActive = function SetJumpButtonActive(isActive) {
            if (isActive) {
                jump_button.interactive = true;
                jump_button.alpha = 1.0;
            }
            else {
                jump_button.interactive = false;
                jump_button.alpha = 0.5;
            }
        };

        if(!CC.isMobile){
            var platform_button = Widgets.createButtonAsset(
                Screens.json.screens.gameScreen.platform_button,
                jumpGame.activateOnScreenCreatablePlatforms.bind(jumpGame),
                true
            );

            var setPlatformButtonActive = function SetPlatformButtonActive(isActive) {
                if (isActive) {
                    platform_button.interactive = true;
                    platform_button.alpha = 1.0;
                }
                else {
                    platform_button.interactive = false;
                    platform_button.alpha = 0.5;
                }
            };
        }

        var attack_button = Widgets.createButtonAsset(
            screenJson.attack_button,
            jumpGame.attackPressed.bind(jumpGame),
            true
        );

        var timeSinceAttacked = 0;
        var attackCoolDownTime = screenJson.attack_button.cool_down_time;

        var coolDown;
        if (CC.isMobile) {
            coolDown = screenJson.attack_button.mobile_cool_down_graphic;
        }
        else {
            coolDown = screenJson.attack_button.desktop_cool_down_graphic;
        }
        attack_button.coolDownGraphic = Widgets.createAsset(coolDown);

        attack_button.addChild(attack_button.coolDownGraphic);
        attack_button.coolDownGraphic.alpha = 0;
        if (attack_button.coolDownGraphic.isAnimated) {
            var coolDownFrameInterval = attackCoolDownTime / coolDown.textures.length;
            attack_button.coolDownGraphic.gotoAndStop(0);
        }

        var startCooldownForAttackButton = function StartCooldownForAttackButton() {
            TweenLite.killTweensOf(attack_button);
            timeSinceAttacked = 0;
            attack_button.scale.set(1, 1);
            attack_button.interactive = false;
            attack_button.coolDownGraphic.alpha = 1;
            if (attack_button.coolDownGraphic.isAnimated) {
                attack_button.coolDownGraphic.gotoAndStop(0);
            }
        };

        var warning = Widgets.createAsset(screenJson.warning_graphic);
        warning.y = -300;

        var scoreBackground = Widgets.createAsset(screenJson.score_bar.back);
        scoreBackground.x = (CC.WebApp.current.screenWidth * -0.5) + (scoreBackground.width * 0.5);
        scoreBackground.y = (CC.WebApp.current.screenHeight * -0.5) + (scoreBackground.height * 0.5)

        var scoreTop = Widgets.createAsset(screenJson.score_bar.top);
        scoreTop.x = (CC.WebApp.current.screenWidth * -0.5) + (scoreTop.width * 0.5);
        scoreTop.y = (CC.WebApp.current.screenHeight * -0.5) + (scoreTop.height * 0.5);

        var scoreText = new PIXI.extras.BitmapText("1", {
            font: screenJson.score_text.textSize + "px FuturaBig",
            tint: screenJson.score_text.tint
        });

        var scoreTextShadow = new PIXI.extras.BitmapText("1", {
            font: screenJson.score_text.textSize + "px FuturaBig",
            tint: 0x0
        });

        var orientationText = new PIXI.extras.BitmapText("Orientation", {
            font: "25px Futura"
        });

        if (this.upsideDown) {
            orientationText.text = "Orientation: " + 180;
        }
        else {
            orientationText.text = "Orientation: " + 0;
        }

        var rotationText = new PIXI.extras.BitmapText("Rotation", {
            font: "25px Futura"
        });

        scoreTextShadow.alpha = 0.25;

        scoreText.x = (-scoreTop.width * 0.5) + (scoreTop.width * 0.33) + (scoreText.width * 0.5);
        scoreText.y = -scoreTop.height * 0.5 + (scoreText.height * 0.5);
        scoreTextShadow.x = scoreText.x + 4;
        scoreTextShadow.y = scoreText.y;

        scoreTop.addChild(scoreTextShadow, scoreText);

        var updatePointsText = function UpdatePointsText(heightScore) {
            scoreText.text = "" + heightScore;
            scoreTextShadow.text = "" + heightScore;
        };

        updatePointsText(0);

        var extraLifeBackground = Widgets.createAsset(screenJson.score_bar.life_background);
        extraLifeBackground.startX = (scoreTop.x + (scoreTop.width * 0.5)) - (extraLifeBackground.width * 0.5);
        extraLifeBackground.endX = (scoreTop.x + (scoreTop.width * 0.5)) + (extraLifeBackground.width * 0.29);
        extraLifeBackground.x = extraLifeBackground.startX;
        extraLifeBackground.y = (CC.WebApp.current.screenHeight * -0.5) + (extraLifeBackground.height * 0.5);

        var extraLifeIcon = Widgets.createAsset(screenJson.score_bar.life);
        var value;
        extraLifeIcon.alpha = 1;

        extraLifeBackground.addChild(extraLifeIcon);

        var setExtraLifeAvailable = function SetExtraLifeAvailable(isAvailable) {

            TweenLite.killTweensOf(extraLifeBackground.position);
            TweenLite.killTweensOf(extraLifeIcon);
            TweenLite.killTweensOf(extraLifeIcon.scale);

            var targetX, time, ease, delay;
            if (isAvailable) {
                extraLifeIcon.scale.set(0);
                extraLifeIcon.alpha = 0;
                targetX = extraLifeBackground.endX;
                value = Math.abs(Math.value(extraLifeBackground.endX, extraLifeBackground.startX, extraLifeBackground.x));
                time = value;
                ease = Bounce.easeOut;
                delay = 0;
                extraLifeBackground.x = extraLifeBackground.startX;
                TweenLite.to(extraLifeIcon.scale, 0.5, {
                    x: 1,
                    y: 1,
                    delay: time * 0.5,
                    ease: Back.easeOut.config(3)
                });
                TweenLite.to(extraLifeIcon, 0.5, {
                    alpha: 1,
                    delay: time * 0.5
                });
            }
            else {
                extraLifeIcon.scale.set(1);
                extraLifeIcon.alpha = 1;
                targetX = extraLifeBackground.startX;
                value = Math.abs(Math.value(extraLifeBackground.startX, extraLifeBackground.endX, extraLifeBackground.x));
                time = value;
                ease = Power2.easeOut;
                delay = 0.5;
                TweenLite.to(extraLifeIcon.scale, 0.5, {x: 2, y: 2});
                TweenLite.to(extraLifeIcon, 0.5, {alpha: 0});
                extraLifeBackground.x = extraLifeBackground.endX;
            }

            TweenLite.to(extraLifeBackground.position, time, {x: targetX, ease: ease, delay: delay});

        };

        container.addChild(
            button_pause,
            jump_button,
            attack_button
        );

        if(platform_button !== undefined){
            container.addChild(
                platform_button
            );
        }

        container.addChild(
            warning,
            scoreBackground,
            extraLifeBackground,
            scoreTop,
            confirm_panel,
            pause_panel,
            help_panel
            //,orientationText
            //,rotationText
        );

        //UI end

        var resizeFunc = function (w, h) {
            button_pause.resize(w, h);
            pause_panel.resize(w, h);
        };

        var updateFunc = function (delta) {

            var newScale;

            if (!paused) {

                jumpGame.update(delta);

                if (!attack_button.interactive) {
                    timeSinceAttacked += delta;

                    if (timeSinceAttacked > attackCoolDownTime) {
                        attack_button.interactive = true;
                        attack_button.coolDownGraphic.alpha = 0;

                        if (attack_button.coolDownGraphic.isAnimated) {
                            attack_button.coolDownGraphic.gotoAndStop(0);
                        }
                    }
                    else if (attack_button.coolDownGraphic.isAnimated) {
                        var currentFrame = attack_button.coolDownGraphic.currentFrame;
                        if (timeSinceAttacked > ((currentFrame + 1) * coolDownFrameInterval)) {
                            attack_button.coolDownGraphic.gotoAndStop(currentFrame + 1);
                        }
                    }
                }

                if(jumpGame.closestEnemy !== undefined){

                    if(jumpGame.closestIndex !== lastEnemyIndex){
                        warning.scale.set(0);
                        lastEnemyIndex = jumpGame.closestIndex;
                    }

                    warning.position.x = jumpGame.closestEnemy.position.x;

                    newScale = 1 - Math.value(200, 900, jumpGame.closestEnemy.distanceToPlayer);

                    if(newScale > warning.scale.x){
                        warning.scale.set(newScale);
                    }
                }
                else{
                    warning.scale.set(0);
                }

            }
        };

        var updateOrientationText = function (orientation) {
            // orientationText.text = "Orientation: " + orientation;
        };

        var updateRotationText = function (rotation) {
            // rotationText.text = "Rotation: " + rotation;
        };

        if (CC.isMobile && !Screens.helpPanelShown) {
            paused = true;
            help_panel.show(closeFunction);
            Screens.helpPanelShown = true;
        }

        return {
            construct: container,
            color: screenJson.screenColour,
            attackButton: attack_button,
            jumpButton: jump_button,
            platformButton: platform_button,
            update: updateFunc,
            resize: resizeFunc,
            setJumpButtonActive: setJumpButtonActive,
            setPlatformButtonActive: setPlatformButtonActive,
            startCooldownForAttackButton: startCooldownForAttackButton,
            updatePointsText: updatePointsText,
            setExtraLifeAvailable: setExtraLifeAvailable,
            updateOrientationText: updateOrientationText,
            updateRotationText: updateRotationText
        };
    },


    /*
     RESULTS SCREEN
     */
    resultsScreen: function (heightScore) {

        var screenJson = Screens.json.screens.resultsScreen;
        sound.play(Screens.json.audio.results_sting);
        if(Screens.json.audio.music.resultsScreen) {
            sound.playMusic(Screens.json.audio.music.resultsScreen);
        }

        var animTimer = 0;

        var record = localStorage.getItem(Screens.json.localStorageName);
        if (record === null) {
            record = 0;
        }

        var newRecordImage = Widgets.createAsset(screenJson.new_record);
        newRecordImage.alpha = 0;

        screenJson.your_score.align = undefined;
        screenJson.your_score.anchor = {x: 0, y: 0.5};
        var yourScoreImage = Widgets.createAsset(screenJson.your_score);

        yourScoreImage.x = -yourScoreImage.width - (CC.WebApp.current.screenWidth / 2);

        TweenLite.to(yourScoreImage.position, 0.5, {x: -(CC.WebApp.current.screenWidth / 2)});

        if (record < heightScore) {
            localStorage.setItem(Screens.json.localStorageName, heightScore);
            newRecordImage.position.y += 60;
            TweenLite.to(newRecordImage, 0.75, {alpha: 1, delay: 2.5});
            TweenLite.to(newRecordImage.position, 0.5, {
                y: newRecordImage.position.y - 60,
                delay: 2.5,
                ease: Back.easeOut.config(1.7)
            });
        }

        var container = new PIXI.Container();
        container.addChild(Widgets.createBackgroundAsset(screenJson.bg));

        screenJson.results_pane.align = undefined;
        screenJson.results_pane.position = undefined;
        screenJson.results_pane.anchor = {x: 0, y: 0.5};
        var resultsPane = Widgets.createAsset(screenJson.results_pane);
        resultsPane.x = -resultsPane.width - (CC.WebApp.current.screenWidth / 2);
        TweenLite.to(resultsPane.position, 0.5, {x: -(CC.WebApp.current.screenWidth / 2), delay: 0.25});

        var font;

        if (screenJson.score_text.size) {
            font = screenJson.score_text.size + "px FuturaBig"
        }
        else {
            font = "100px FuturaBig"
        }

        var tempScoreText = new PIXI.extras.BitmapText(0 + "", {
            font: font,
            tint: screenJson.score_text.tint
        });
        Widgets.setAssetParams(tempScoreText, screenJson.score_text);

        if (screenJson.record_text.size) {
            font = screenJson.record_text.size + "px FuturaBig"
        }
        else {
            font = "60px FuturaBig"
        }

        var tempRecordText = new PIXI.extras.BitmapText(record + "", {
            font: font,
            tint: screenJson.record_text.tint
        });
        Widgets.setAssetParams(tempRecordText, screenJson.record_text);

        tempScoreText.x -= tempScoreText.textWidth / 2;
        tempRecordText.x -= tempRecordText.textWidth / 2;
        tempScoreText.y -= tempScoreText.textHeight / 2;
        tempRecordText.y -= tempRecordText.textHeight / 2;

        tempScoreText.alpha = 0;
        tempRecordText.alpha = 0;

        TweenLite.to(tempScoreText, 1.0, {alpha: 1, delay: 1});
        TweenLite.to(tempRecordText, 1.0, {alpha: 1, delay: 1});

        tempScoreText.scoreTweenValue = 0;
        TweenLite.to(tempScoreText, 2.0, {
            scoreTweenValue: heightScore,
            delay: 1,
            ease: Power2.easeOut,
            onStart: function() {
                sound.play(Screens.json.audio.tally, 1, true);
            }.bind(tempScoreText),
            onComplete: function() {
                sound.stop(Screens.json.audio.tally);
            }
        });

        var button_tick = Widgets.createButtonAsset(screenJson.tick_btn, function () {
            CC.WebApp.current.swapScreen(Screens.challengeDisplayScreen({showResults: true}));
        });

        var button_home = Widgets.createButtonAsset(Screens.json.ui.button_home, function () {
            CC.WebApp.current.swapScreen(Screens.startScreen())
        });

        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var settings_panel = Widgets.createSettingsMenu(Screens.json.ui.panel_settings, help_panel);
        var button_settings = Widgets.createButtonAsset(Screens.json.ui.button_settings, function () {
            settings_panel.show();
        });

        var screenItems;
        screenItems = [resultsPane, newRecordImage, yourScoreImage, tempScoreText, tempRecordText, button_tick, button_home, button_settings, settings_panel, help_panel];
        container.addChild(resultsPane, newRecordImage, yourScoreImage, tempScoreText, tempRecordText, button_tick, button_home, button_settings, settings_panel, help_panel);

        var resizeFunc = function (w, h) {
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if (item.resize) {
                    item.resize(w, h);
                }
            }
        };


        var updateFunc = function (delta) {

            tempScoreText.text = Math.ceil(tempScoreText.scoreTweenValue);

            animTimer += delta;
            var modifier = Math.pow(Math.sin(animTimer * Math.PI), 12);
            button_tick.scale.x = 1 + modifier * 0.1;
            button_tick.scale.y = button_tick.scale.x;

        };
        return {
            construct: container,
            color: screenJson.screenColour,
            update: updateFunc,
            resize: resizeFunc
        };
    },


    /*
     UNLOCK SCREEN
     */
    unlockScreen: function (unlockedItems) {
        var screenJson = Screens.json.screens.unlockScreen;
        sound.stopMusic();

        if(Screens.json.audio.music.unlockedItems) {
            sound.playMusic(Screens.json.audio.music.unlockedItems);
        }

        sound.play(Screens.json.audio.unlock);

        var container = new PIXI.Container();

        var bg = Widgets.createBackgroundAsset(screenJson.bg);
        container.addChild(bg);

        var unlockContainer = new PIXI.Container();
        if (unlockedItems[0].type == "character") {
            unlockContainer.addChild(Widgets.createAsset(unlockedItems[0].image));
        } else {
            unlockContainer.addChild(Widgets.createBackgroundAsset(unlockedItems[0].image));
        }

        var title = Widgets.createAsset(screenJson.title);

        var index = 0;
        var continueFunction = function () {
            index++;
            if (unlockedItems.length == index) {
                CC.WebApp.current.swapScreen(Screens.startScreen());
            } else {
                sound.play(Screens.json.audio.unlock);
                if (unlockContainer.children.length > 0) {
                    unlockContainer.removeChild(unlockContainer.children[0]);
                }
                if (unlockedItems[index].type == "character") {
                    unlockContainer.addChild(Widgets.createAsset(unlockedItems[index].image));
                } else {
                    unlockContainer.addChild(Widgets.createBackgroundAsset(unlockedItems[index].image));
                }
            }
        };

        var button_continue = Widgets.createButtonAsset(Screens.json.ui.button_continue_alt, continueFunction, Screen.json);
        container.addChild(unlockContainer, title, button_continue);

        var screenItems = [unlockContainer, title, button_continue];

        var resizeFunc = function (w, h) {
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if (item.resize) {
                    item.resize(w, h);
                }
            }
        };

        var updateFunc = function (delta) {
        };
        return {
            construct: container,
            color: 0xEEEEEE,
            update: updateFunc,
            resize: resizeFunc
        };
    },

    /*
     CHALLENGE DISPLAY SCREEN
     */
    challengeDisplayScreen: function (config) {

        config = config ? config : {};

        var screenJson = Screens.json.screens.challengeDisplayScreen;

        if (config.showResults) {
            var record = localStorage.getItem(Screens.json.localStorageName);
        }

        var container = new PIXI.Container();
        if (screenJson.bg) {
            var bg = Widgets.createBackgroundAsset(screenJson.bg);
            container.addChild(bg);
        }

        var screenItems = [];
        var challengesPane = Widgets.createAsset(screenJson.challenges_pane);
        container.addChild(challengesPane);
        screenItems.push(challengesPane);

        var i = 0, challengeKey, currentScore, levelKey, currentLevel, levelValue, awardConfig;

        if (config.showResults) {
            var buttonTweenWait = 0.5, heightScore, addKey, scoreAdd, scoreTotal, addWaitingAward;
        }
        else {
            var animTimer = 0;
        }

        var awards = [], waitingAwards = [];
        var startY = -175;

        for (i; i < Screens.challengeKeys.length; i += 1) {

            addWaitingAward = true;

            awardConfig = {};
            awardConfig.json = screenJson;
            awardConfig.key = Screens.challengeKeys[i];

            if (config.showResults) {
                awardConfig.doTween = true;
            }

            challengeKey = Screens.json.localStorageName + "_" + Screens.challengeKeys[i];
            currentScore = parseInt(localStorage.getItem(challengeKey), 10);
            if (!currentScore) {
                currentScore = 0;
            }

            levelKey = Screens.json.localStorageName + "_" + Screens.challengeKeys[i] + "_level";
            currentLevel = parseInt(localStorage.getItem(levelKey), 10);
            if (!currentLevel) {
                currentLevel = 0;
            }

            if (screenJson.challenges[Screens.challengeKeys[i]].levels.length <= currentLevel) {
                currentLevel = screenJson.challenges[Screens.challengeKeys[i]].levels.length - 1;
                awardConfig.doTween = false;
                currentScore = screenJson.challenges[Screens.challengeKeys[i]].levels[currentLevel];
                scoreTotal = currentScore;
            }

            if (currentLevel === screenJson.challenges[Screens.challengeKeys[i]].levels.length - 1) {
                addWaitingAward = false;
            }

            levelValue = screenJson.challenges[Screens.challengeKeys[i]].levels[currentLevel];

            if (config.showResults) {
                if (awardConfig.doTween) {
                    addKey = Screens.json.localStorageName + "_" + Screens.challengeKeys[i] + "_add";
                    scoreAdd = parseInt(localStorage.getItem(addKey), 10);
                    if (!scoreAdd) {
                        scoreAdd = 0;
                    }
                    else {
                        buttonTweenWait = 2;
                    }

                    if (Screens.challengeKeys[i] === "height") {
                        heightScore = scoreAdd;
                    }

                    if (Screens.challengeTypes[Screens.challengeKeys[i]] === "cumulative") {
                        scoreTotal = currentScore + scoreAdd;
                    }
                    else {
                        scoreTotal = scoreAdd;
                    }

                    if (scoreTotal >= levelValue) {
                        scoreTotal = levelValue;
                        localStorage.setItem(challengeKey, 0);
                        currentLevel += 1;
                        localStorage.setItem(levelKey, currentLevel);
                        buttonTweenWait = 4.5;
                        if(addWaitingAward){
                            awardConfig.disappear = true;
                        }
                    }
                    else {
                        addWaitingAward = false;
                        if (Screens.challengeTypes[Screens.challengeKeys[i]] === "cumulative") {
                            localStorage.setItem(challengeKey, scoreTotal);
                        }
                    }
                }

                if (addWaitingAward) {

                    waitingAwards[i] = new ChallengeAward({
                        endScore: 0,
                        levelValue: screenJson.challenges[Screens.challengeKeys[i]].levels[currentLevel + 1],
                        doTween: false,
                        json: screenJson,
                        key: Screens.challengeKeys[i]
                    });

                    waitingAwards[i].y = startY + (i * 155) + 20;
                    waitingAwards[i].alpha = 0;

                    TweenLite.to(waitingAwards[i], 0.25, {alpha: 1, delay: 4.5});
                    TweenLite.to(waitingAwards[i].position, 0.5, {y: waitingAwards[i].position.y - 20, delay: 4.5});

                    buttonTweenWait = 7;
                    container.addChild(waitingAwards[i]);
                }

                awardConfig.levelValue = levelValue;
                awardConfig.startScore = currentScore;
                awardConfig.endScore = scoreTotal;
            }
            else {
                awardConfig.endScore = currentScore;
                awardConfig.levelValue = levelValue;
            }

            awards.push(new ChallengeAward(awardConfig));
            awards[i].y = startY + (i * 155);
            container.addChild(awards[i]);
        }

        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var settings_panel = Widgets.createSettingsMenu(Screens.json.ui.panel_settings, help_panel);
        var button_settings = Widgets.createButtonAsset(Screens.json.ui.button_settings, function () {
            settings_panel.show();
        });

        var updateFunc;

        var button_home = Widgets.createButtonAsset(
            config.showResults ? Screens.json.ui.button_home_alt : Screens.json.ui.button_home,
            function () {
                CC.WebApp.current.swapScreen(Screens.startScreen())
            });

        var resizeFunc = function (w, h) {
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if (item.resize) {
                    item.resize(w, h);
                }
            }
        };

        if (config.showResults) {
            var buttonContainer = new PIXI.Container();

            var button_replay = Widgets.createButtonAsset(Screens.json.ui.button_replay, function () {
                CC.WebApp.current.swapScreen(Screens.gameScreen())
            });

            var continueFunction = function () {
                var characters = Screens.json.screens.characterScreen.characters;
                var unlockedItems = [];
                var obj;
                for (var i = 0; i < characters.length; i++) {
                    obj = characters[i];
                    if (obj.unlockScore) {
                        if (!localStorage.getItem(Screens.json.localStorageName + "_character_" + i) && obj.unlockScore <= heightScore) {
                            localStorage.setItem(Screens.json.localStorageName + "_character_" + i, true);
                            obj.type = "character";
                            unlockedItems.push(obj);
                        }
                    }
                }
                if (unlockedItems.length > 0) {
                    CC.WebApp.current.swapScreen(Screens.unlockScreen(unlockedItems));
                } else {
                    CC.WebApp.current.swapScreen(Screens.characterScreen());
                }
            };

            var button_continue = Widgets.createButtonAsset(Screens.json.ui.button_continue, continueFunction);

            buttonContainer.addChild(button_home);
            buttonContainer.addChild(button_replay);
            buttonContainer.addChild(button_continue);

            buttonContainer.interactive = false;
            buttonContainer.alpha = 0;

            TweenLite.to(buttonContainer, 1, {
                alpha: 1,
                delay: buttonTweenWait,
                onComplete: (function (buttonContainer) {
                    return function () {
                        buttonContainer.interactive = true;
                    }
                }(buttonContainer))
            });

            container.addChild(buttonContainer, button_settings, settings_panel, help_panel);

            screenItems.push(buttonContainer, button_settings, settings_panel, help_panel);

            var updateFunc = function (delta) {
                var i = 0;
                for (i; i < awards.length; i += 1) {
                    awards[i].update(delta);
                }
            };

        }
        else {
            var button_tick = Widgets.createButtonAsset(screenJson.tick_btn, function () {
                CC.WebApp.current.swapScreen(Screens.gameScreen());
            });

            container.addChild(button_tick, button_home, button_settings, settings_panel, help_panel);

            screenItems.push(button_tick, button_home, button_settings, settings_panel, help_panel);

            updateFunc = function (delta) {
                animTimer += delta;
                var modifier = Math.pow(Math.sin(animTimer * Math.PI), 12);
                button_tick.scale.x = 1 + modifier * 0.1;
                button_tick.scale.y = button_tick.scale.x;
            };
        }

        return {
            construct: container,
            color: screenJson.screenColour,
            update: updateFunc,
            resize: resizeFunc
        };
    }

};